import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "BackOut"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19.5 22.5H10.5C9.67192 22.4992 9.00083 21.8281 9 21V18.75H10.5V21H19.5V3H10.5V5.25H9V3C9.00083 2.17192 9.67192 1.50083 10.5 1.5H19.5C20.3281 1.50083 20.9992 2.17192 21 3V21C20.9992 21.8281 20.3281 22.4992 19.5 22.5ZM8.5605 15.4395L5.871 12.75H16.5V11.25H5.871L8.5605 8.5605L7.5 7.5L3 12L7.5 16.5L8.5605 15.4395Z"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/BackOut.vue"]]);
